import {EntrySummary} from 'notebook/ELNConstants';

import {ExecuteRequestFlowAction} from '../ExecuteRequestFlowReduxActions';
import {ExistingEntryAction, ExistingEntryActionType} from './ExistingEntryReduxActions';

export interface ExistingEntryState {
  selectedEntry: EntrySummary | null;
}

export default function reduceExistingEntry(
  state: ExistingEntryState = {selectedEntry: null},
  action: ExistingEntryAction | ExecuteRequestFlowAction
): ExistingEntryState {
  switch (action.type) {
    case ExistingEntryActionType.SET_SELECTED_ENTRY: {
      const {selectedEntry} = action;
      return {
        ...state,
        selectedEntry,
      };
    }
    default:
      return state;
  }
}
